import React, { useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import * as ActionType from "../store/shorts/shorts.type";
import {
  IconButton,
  Modal,
  Box,
  Stack,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { getHashTagApi, getShortsApi } from "../store/shorts/shorts.action";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 450 },
  bgcolor: "background.paper",
  border: "1px solid #ddd",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 3,
};

const FilterIconWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "inline-block",
}));

const ClearIconOverlay = styled(ClearIcon)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  fontSize: 15,
  backgroundColor: "red",
  color: "white",
  cursor: "pointer",
  zIndex: 1,
  borderRadius: 20,
}));

const FilterModel = (props) => {
  const {
    firstField,
    firstFieldName,
    secondField,
    secondFieldName,
    ModelName,
    feature,
    options,
    hasActiveFilters,
    setHasActiveFilters,
    filterType,
    start,
    limit,
    startDate,
    endDate,
    setFilter,
  } = props;
  const dispatch = useDispatch();
  const [tempSearchText, setTempSearchText] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("");

  const [tempFeature, setTempFeature] = useState(""); // Changed to a single string for temporary storage
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const [channelId, setChannelId] = useState("");
  const [filters, setFilters] = useState({
    searchText: "",
    searchCategory: "",
    feature: "", // Changed to a single string to store one feature value
  });
  const handleAutocompleteChange = (event, newValue) => {
    if (!newValue) {
      setSelectedChannel("");
      setChannelId("");
      return;
    }
    setSelectedChannel(newValue.label);
    setChannelId(newValue.id);
    // Perform other actions with the selected value here
  };

  const handleOpenFilterModal = () => {
    setTempSearchText(filters.searchClip);
    setSelectedChannel(filters.searchChannel);
    setTempFeature(filters.feature);
    setChannelId(filters.channelId);
    setIsFilterModalOpen(true);
  };

  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false);
  };
  //apply filter
  const applyFilters = () => {
    const newFilters = {
      searchClip: tempSearchText,
      searchChannel: selectedChannel,
      feature: tempFeature, // Single feature value
      channelId: channelId,
    };
    setFilters(newFilters);
    setIsFilterModalOpen(false);

    const areFiltersActive = Object.values(newFilters).some(
      (value) => value !== "" && value !== null && value !== undefined
    );
    setHasActiveFilters(areFiltersActive);
    if (areFiltersActive) {
      if (filterType === "FilterShort") {
        let data = {
          filter1: newFilters.searchClip || "",
          filter2: newFilters.channelId || "",
          filter3: newFilters.feature || "",
        };
        setFilter(data);
        dispatch(getShortsApi(data, 2, start, limit, startDate, endDate));
      }
    }
    if (filterType === "FilterTags") {
      let data = {
        filter1: newFilters.searchClip || "",
        filter2: newFilters.feature || "",
      };
      setFilter(data);
      dispatch(getHashTagApi(data, start, limit));
    }
  };

  const clearFilters = () => {
    setFilters({
      searchClip: "",
      searchChannel: "",
      feature: "",
      channelId: "",
    });
    setHasActiveFilters(false);
    setTempSearchText("");
    setSelectedChannel("");
    setTempFeature("none");
    setChannelId("");

    if (filterType === "FilterShort") {
      let data = {
        filter1: "",
        filter2: "",
        filter3: "",
      };
      setFilter(data);
      dispatch(getShortsApi(data, 2, start, limit, startDate, endDate));
    }
    if (filterType === "FilterTags") {
      let data = {
        filter1: "",
        filter2: "",
      };
      setFilter(data);
      dispatch(getHashTagApi(data, start, limit));
    }
  };

  const handleFeatureChange = (event) => {
    setTempFeature(event.target.value); // Update tempFeature with the selected value
  };

  return (
    <div>
      <IconButton onClick={handleOpenFilterModal}>
        <FilterIconWrapper>
          <FilterListIcon sx={{ fontSize: 40, color: "#d00101" }} />
          {hasActiveFilters && (
            <ClearIconOverlay
              onClick={(e) => {
                e.stopPropagation();
                clearFilters();
              }}
            />
          )}
        </FilterIconWrapper>
      </IconButton>

      <Modal
        open={isFilterModalOpen}
        onClose={handleCloseFilterModal}
        aria-labelledby="filter-modal-title"
        aria-describedby="filter-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography
            variant="h5"
            component="h2"
            id="filter-modal-title"
            gutterBottom
          >
            {ModelName}
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom>
            Filters
          </Typography>

          <Stack spacing={2}>
            {firstField && (
              <TextField
                label={firstFieldName}
                variant="outlined"
                fullWidth
                value={tempSearchText}
                onChange={(e) => setTempSearchText(e.target.value)}
              />
            )}
            {secondField && (
              <Autocomplete
                fullWidth
                disablePortal
                options={options}
                value={selectedChannel}
                renderInput={(params) => (
                  <TextField {...params} label={secondFieldName} />
                )}
                onChange={handleAutocompleteChange}
              />
            )}
            {feature && (
              <FormControl component="fieldset">
                <Typography variant="subtitle1">Feature Clip</Typography>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tempFeature === "feature"}
                        onChange={handleFeatureChange}
                        value="feature"
                      />
                    }
                    label="Feature"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tempFeature === "notFeature"}
                        onChange={handleFeatureChange}
                        value="notFeature"
                      />
                    }
                    label="Not Feature"
                  />
                </FormGroup>
              </FormControl>
            )}
          </Stack>

          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 3 }}
          >
            <Button variant="outlined" onClick={handleCloseFilterModal}>
              Cancel Filter
            </Button>
            <Button variant="contained" onClick={applyFilters}>
              Apply Filter
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default FilterModel;
